import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import StaffOnboardPage from './StaffOnboardPage';
import ApplyPage from './ApplyPage';
import GroupSignInPage from './GroupSignInPage';
import OnboardingPage from './OnboardingPage';
import ResetPage from './ResetPage';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// TENANT CONTEXT (2026-09-11): orgWide users operate inside one tenant at a time.
// Every API call carries X-Tenant from localStorage; the api validates it
// server-side (bad values fall back to the user's home tenant, never widen scope).
const __tcioTenant = () => localStorage.getItem('tcio_active_tenant') || '';
axios.interceptors.request.use((cfg) => {
  const t = __tcioTenant();
  if (t) cfg.headers['X-Tenant'] = t;
  return cfg;
});
const __origFetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  const t = __tcioTenant();
  if (t) {
    init = init || {};
    init.headers = Object.assign({}, init.headers instanceof Headers ? Object.fromEntries(init.headers.entries()) : (init.headers || {}), { 'X-Tenant': t });
  }
  return __origFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {window.location.pathname.startsWith('/group-sign-in') ? <GroupSignInPage token={window.location.pathname.split('/')[2] || ''} /> : window.location.pathname.startsWith('/apply/') ? <ApplyPage token={window.location.pathname.split('/')[2] || ''} /> : window.location.pathname.startsWith('/staff-onboard/') ? <StaffOnboardPage token={window.location.pathname.split('/')[2] || ''} /> : window.location.pathname.startsWith('/onboard/') ? <OnboardingPage token={window.location.pathname.split('/')[2] || ''} /> : window.location.pathname.startsWith('/reset/') ? <ResetPage token={window.location.pathname.split('/')[2] || ''} /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
